module.exports = __webpack_public_path__ + "static/media/logo.fbe94ec7.png";